import { SaveButton } from "components/Buttons"
import { TagsMultiSelect } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field, reduxForm } from "redux-form"

const Tags = ({
  metaTags = [],
  onTagCreate,
  dirty,
  saveLoading,
  handleSubmit,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <h5 className="font-size-14 mb-0">
        <i className="mdi mdi-arrow-right text-primary"></i> Tags
      </h5>
      <Row className="my-3">
        <Col>
          <Field
            name={"tags"}
            component={TagsMultiSelect}
            create={onTagCreate}
            options={metaTags.map(({ id, tag }) => ({ value: id, label: tag }))}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-end">
        <Col xs="auto" className="my-2">
          <SaveButton
            content={"Save"}
            loading={saveLoading}
            disabled={!dirty}
          />
        </Col>
      </Row>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAMES.PROFILE_TAGS,
})(Tags)
